import { Link } from "react-router-dom";
import { CaretRight, Trophy, Horse } from "@phosphor-icons/react";

export default function HorseCard({ horse }) {
  const winRate = horse.total_races > 0
    ? ((horse.total_wins / horse.total_races) * 100).toFixed(0)
    : 0;

  return (
    <Link
      to={`/horse/${horse.id}`}
      data-testid={`horse-card-${horse.id}`}
      className="group border border-border p-4 hover:bg-zinc-50 transition-colors flex items-center justify-between"
    >
      <div className="flex items-center gap-4">
        <div className="w-10 h-10 bg-zinc-100 border border-border flex items-center justify-center">
          <Horse weight="bold" size={20} className="text-zinc-400" />
        </div>
        <div>
          <h3 className="text-sm font-semibold text-zinc-900 group-hover:text-[#E12B00] transition-colors">
            {horse.name}
          </h3>
          <p className="text-xs text-zinc-500">
            {horse.age}yo {horse.sex} &middot; {horse.trainer}
          </p>
        </div>
      </div>
      <div className="flex items-center gap-4">
        <div className="text-right">
          <div className="flex items-center gap-1">
            <Trophy weight="fill" size={12} className="text-[#008A27]" />
            <span className="font-mono text-sm font-bold">{horse.total_wins}/{horse.total_races}</span>
          </div>
          <p className="font-mono text-xs text-zinc-400">{winRate}% SR</p>
        </div>
        <div className="flex items-center gap-1 font-mono text-xs text-zinc-400">
          <span>{horse.form}</span>
        </div>
        <CaretRight weight="bold" size={16} className="text-zinc-300 group-hover:text-[#E12B00] transition-colors" />
      </div>
    </Link>
  );
}
